import { useCallback } from "react";
import { chemistryMeasurementsEqual } from "components/materialChemistry/chemistryMeasurements";
import {
  MaterialChemistry,
  MaterialChemistrySetRead,
  UpdateDefaultMaterialChemistryRequest,
} from "store/api/generatedApi";
import { useDefaultSetDraft } from "./useDefaultSetDraft";

const EMPTY_OVERRIDES: MaterialChemistry[] = [];
const chemistryHasChanged = (
  source: MaterialChemistrySetRead,
  measurement: MaterialChemistry
): boolean => {
  const original = source.items.find(
    (candidate) =>
      candidate.material_id === measurement.material_id &&
      candidate.chemical_element_id === measurement.chemical_element_id
  );
  return !chemistryMeasurementsEqual(original, measurement);
};

export const useMaterialChemistryDraft = (
  defaultSet: MaterialChemistrySetRead
) => {
  const draft = useDefaultSetDraft({
    defaultSet,
    emptyOverrides: EMPTY_OVERRIDES,
    hasChanged: chemistryHasChanged,
  });
  const commitDraft = draft.save;

  const save = useCallback(
    (
      commit: (
        request: UpdateDefaultMaterialChemistryRequest
      ) => Promise<unknown>
    ) =>
      commitDraft((source, overrides) =>
        commit({
          source_material_chemistry_set_id: source.id,
          material_chemistry_overrides: overrides,
        })
      ),
    [commitDraft]
  );
  return { ...draft, save };
};
